import FashBusinesses from "./FashBusinesses";
import ViewMore from "./ViewMore";

export { FashBusinesses, ViewMore };
